module.exports = "<div class=\"btn-group\">\n    <content select=\"[data-toggle='dropdown']\" ></content>\n    <content select=\"ul.dropdown-menu\"></content>\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Dropdown.vue
 ** module id = 105
 ** module chunks = 0
 **/